/**
 * @enum {string}
 */
export const UiStrings = {
  NoMatchingResults: 'No matching results',
}

export const name = 'number'

export const getPlaceholder = () => {
  return ''
}

export const getHelpEntries = () => {
  return []
}

export const getNoResults = () => {
  return {
    label: UiStrings.NoMatchingResults,
  }
}

export const getPicks = async () => {
  const picks = [
    {
      label: '1',
    },
    {
      label: '2',
    },
    {
      label: '3',
    },
    {
      label: '4',
    },
    {
      label: '5',
    },
    {
      label: '6',
    },
    {
      label: '7',
    },
    {
      label: '8',
    },
    {
      label: '9',
    },
    {
      label: '10',
    },
  ]
  return picks
}

export const selectPick = async (item) => {
  return {
    command: 'hide',
  }
}
